import {v4 as uuid} from 'uuid';

export const ONBOARDING_STEPS = {
  CONSENT_FORM: 'consentForm',
  USER_TYPE_SELECTION: 'userTypeSelection',
  FEATURE_SELECTION: 'featureSelection',
} as const;

export type OnboardingStep =
  (typeof ONBOARDING_STEPS)[keyof typeof ONBOARDING_STEPS];

export const ONBOARDING_STEPS_ORDER: OnboardingStep[] = [
  ONBOARDING_STEPS.CONSENT_FORM,
  ONBOARDING_STEPS.USER_TYPE_SELECTION,
  ONBOARDING_STEPS.FEATURE_SELECTION,
];

export const ONBOARDING_STEPS_PRESENTATION_ID: Record<OnboardingStep, string> =
  Object.fromEntries(
    ONBOARDING_STEPS_ORDER.map((step) => [step, uuid()])
  ) as Record<OnboardingStep, string>;
